/* Unofficial Alton Towers: direct ThemeParks.wiki schedule with optional legacy Waterpark fallback.
   Dates and operating-state transitions use Europe/London, never device-local time. */
(function(){
  "use strict";
  var roots=document.querySelectorAll("[data-uato-park-hours]");
  if(!roots.length)return;
  var zone="Europe/London",scheduled=null,loading=false,waterData=null;
  function elements(root){var find=function(s){return root.querySelector(s)};
    return {root:root,date:find("[data-park-today]"),theme:{hours:find("[data-theme-hours]"),status:find("[data-theme-state]")},water:{hours:find("[data-water-hours]"),status:find("[data-water-state]")},updated:find("[data-park-update]"),note:find("[data-park-note]")};
  }
  var panels=Array.from(roots).filter(function(r){if(r.dataset.ready==="yes")return false;r.dataset.ready="yes";return true}).map(elements);
  if(!panels.length)return;
  function ukParts(value){
    var date=new Date(value),out={};
    new Intl.DateTimeFormat("en-GB",{timeZone:zone,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",hourCycle:"h23"}).formatToParts(date).forEach(function(x){out[x.type]=x.value});
    return {day:out.year+"-"+out.month+"-"+out.day,mins:Number(out.hour)*60+Number(out.minute)};
  }
  function tomorrow(day){var p=day.split("-").map(Number);return new Date(Date.UTC(p[0],p[1]-1,p[2]+1,12)).toISOString().slice(0,10)}
  function displayDay(day){
    var p=day.split("-").map(Number);return new Intl.DateTimeFormat("en-GB",{timeZone:zone,weekday:"long",day:"numeric",month:"long",year:"numeric"}).format(new Date(Date.UTC(p[0],p[1]-1,p[2],12)));
  }
  function clock(date){if(!date||!Number.isFinite(Date.parse(date)))return null;return new Intl.DateTimeFormat("en-GB",{timeZone:zone,hour:"numeric",minute:"2-digit",hour12:true}).format(new Date(date)).replace(/\s/g,"").toLowerCase()}
  function checkedTime(){return new Intl.DateTimeFormat("en-GB",{timeZone:zone,hour:"2-digit",minute:"2-digit",day:"numeric",month:"short"}).format(new Date())}

  function minutes(value){
    if(typeof value==="number")return value>=0&&value<1440?value:null;
    if(typeof value!=="string")return null;
    var s=value.trim().toLowerCase().replace(/\s+/g,"");
    if(/^\d{4}-\d\d-\d\dT/.test(s)){var parsed=Date.parse(s);return Number.isFinite(parsed)?ukParts(parsed).mins:null}
    var match=s.match(/^(\d{1,2})(?::?(\d{2}))?(am|pm)?$/);
    if(!match)return null;
    var hour=Number(match[1]),minute=Number(match[2]||0),period=match[3];
    if(minute>59||hour>23||period&&(hour<1||hour>12))return null;
    if(period)hour=hour%12+(period==="pm"?12:0);
    return hour*60+minute;
  }
  function formatMins(time){
    if(time===null)return null;
    var h=Math.floor(time/60),m=time%60;
    return (h%12||12)+(m?":"+String(m).padStart(2,"0"):"")+(h>=12?"pm":"am");
  }
  function findPark(day){if(!scheduled||!Array.isArray(scheduled.park))return null;
    return scheduled.park.find(function(item){return item&&item.date===day&&item.type==="OPERATING"&&Number.isFinite(Date.parse(item.openingTime))&&Number.isFinite(Date.parse(item.closingTime))})||null;
  }
  function findWater(day){return scheduled&&scheduled.waterpark?scheduled.waterpark[day]||null:null}
  function normalizedWater(raw,day){
    if(raw===null||raw===undefined)return null;
    if(typeof raw==="string"){
      var t=raw.trim();
      if(/\bclosed\b|\bseasonal\s+closure\b|\bnot\s+open\b/i.test(t))return {status:"CLOSED"};
      var times=t.match(/(\d{1,2}(?::\d{2})?\s*(?:am|pm)?)\s*(?:-|–|—|\bto\b)\s*(\d{1,2}(?::\d{2})?\s*(?:am|pm)?)/i);
      if(!times)return null;
      return normalizedWater({open:times[1],close:times[2]},day);
    }
    if(typeof raw!=="object")return null;
    if(raw.date&&raw.date!==day)return null;
    var status=String(raw.status||raw.type||"").toUpperCase();
    if(/\bCLOSED\b|\bSEASONAL\b|\bSHUT\b/.test(status))return {status:"CLOSED"};
    var open=raw.open??raw.opens??raw.start??raw.openingTime??raw.opening_time??raw.open_time??raw.opensAt??raw.opening;
    var close=raw.close??raw.closes??raw.end??raw.closingTime??raw.closing_time??raw.close_time??raw.closesAt??raw.closing;
    if(open===undefined||close===undefined){
      var range=raw.hours||raw.openingHours||raw.opening_hours||raw.times||raw.time;
      return range===raw?null:normalizedWater(range,day);
    }
    var from=minutes(open),to=minutes(close);
    if(from===null||to===null||from===to)return null;
    return {status:"OPERATING",open:from,close:to};
  }
  function waterFromSnapshot(snapshot,day,isTomorrow){
    if(!snapshot||typeof snapshot!=="object")return null;
    var data=snapshot.opening_times||snapshot.openingTimes||snapshot.data||snapshot;
    var dated=data.by_date?.[day]||data.byDate?.[day]||data.dates?.[day]||data.days?.[day]||data.waterpark?.[day];
    var raw=dated&&(dated.waterpark??dated.waterPark??dated.water_park??dated);
    var waterBucket=data.waterpark??data.waterPark??data.water_park;
    if(!raw&&waterBucket&&typeof waterBucket==="object"){
      raw=waterBucket[day]??waterBucket[isTomorrow?"tomorrow":"today"]??waterBucket[isTomorrow?"next_day":"current"]??null;
    }
    if(!raw&&Array.isArray(data.schedule)){
      var match=data.schedule.find(function(x){return x&&x.date===day});
      if(match)raw=match.waterpark??match.waterPark??match.water_park??null;
    }
    if(!raw){
      var period=isTomorrow?(data.tomorrow||data.next_day||data.nextDay||data.next):(data.today||data.current);
      raw=period&&(period.waterpark??period.waterPark??period.water_park);
      if(!raw)raw=isTomorrow?(data.waterpark_tomorrow||data.waterparkTomorrow):(data.waterpark_today||data.waterparkToday);
      if(!raw&&!isTomorrow)raw=data.waterpark||data.waterPark||data.water_park;
    }
    return normalizedWater(raw,day);
  }
  function showVenue(box,kind,item,day,isTomorrow,uk){
    if(!box.hours||!box.status)return;
    if(!item){
      box.hours.textContent=kind==="water"?"Waterpark hours unavailable":"No hours published for this date";
      box.status.textContent="Check hours";box.status.dataset.state="unknown";return;
    }
    if(kind==="water"&&item.status==="CLOSED"){
      box.hours.textContent=isTomorrow?"Closed tomorrow":"Closed today";
      box.status.textContent="Closed";box.status.dataset.state="closed";return;
    }
    var open=kind==="park"?clock(item.openingTime):formatMins(item.open);
    var close=kind==="park"?clock(item.closingTime):formatMins(item.close);
    if(!open||!close){
      box.hours.textContent="Check opening times";box.status.textContent="Unverified";box.status.dataset.state="unknown";return;
    }
    box.hours.textContent=open+" – "+close;
    if(isTomorrow){box.status.textContent="Scheduled";box.status.dataset.state="unknown";return}
    var ongoing=kind==="park"?
      Date.now()>=Date.parse(item.openingTime)&&Date.now()<Date.parse(item.closingTime):
      (item.open<item.close?uk.mins>=item.open&&uk.mins<item.close:uk.mins>=item.open||uk.mins<item.close);
    box.status.textContent=ongoing?"Open now":"Closed now";
    box.status.dataset.state=ongoing?"open":"closed";
  }

  function render(){
    var uk=ukParts(Date.now()),day=uk.day,nextDay=tomorrow(day);
    var themeToday=findPark(day),waterToday=findWater(day);
    // Each venue advances on its own closing time: the Waterpark may finish earlier.
    var themeTomorrow=!!(themeToday&&Date.now()>=Date.parse(themeToday.closingTime));
    var waterTomorrow=!!(waterToday&&waterToday.status==="OPERATING"&&
      Number.isFinite(waterToday.close)&&Number.isFinite(waterToday.open)&&
      waterToday.close>waterToday.open&&uk.mins>=waterToday.close);
    var themeDay=themeTomorrow?nextDay:day,waterDay=waterTomorrow?nextDay:day;
    var theme=findPark(themeDay),water=findWater(waterDay);
    panels.forEach(function(panel){
      if(panel.date){
        panel.date.textContent=themeTomorrow===waterTomorrow?
          (themeTomorrow?"Tomorrow: ":"Today: ")+displayDay(themeDay):
          "Today: "+displayDay(day)+" · Venue schedules update independently";
      }
      var subtitles=panel.root.querySelectorAll(".uato-park-opening__venue-sub");
      if(subtitles[0])subtitles[0].textContent=(themeTomorrow?"Tomorrow's":"Today's")+" Theme Park hours";
      if(subtitles[1])subtitles[1].textContent=(waterTomorrow?"Tomorrow's":"Today's")+" Waterpark hours";
      showVenue(panel.theme,"park",theme,themeDay,themeTomorrow,uk);
      showVenue(panel.water,"water",water,waterDay,waterTomorrow,uk);
      if(!scheduled){panel.updated.textContent="Opening hours have not yet been verified."}
      else{panel.updated.textContent="Published schedule · Checked "+checkedTime()+" (UK time)"}
      panel.note.textContent=water?
        "Theme Park: ThemeParks.wiki · Waterpark: resort data feed. Times can change.":
        "Waterpark times are not available from our data feed. Confirm with Alton Towers before travelling.";
    });
  }

  async function legacyWater(root){
    var endpoint=root.dataset.parkInfoUrl,key=root.dataset.parkInfoKey;
    if(!endpoint||!key)return null;
    var controller=typeof AbortController==="function"?new AbortController():null;
    var timer=controller?setTimeout(function(){controller.abort()},6500):null;
    try{
      var url=endpoint+(endpoint.indexOf("?")>=0?"&":"?")+"order=scraped_at.desc&limit=12";
      var res=await fetch(url,{mode:"cors",cache:"no-store",headers:{Accept:"application/json",apikey:key,Authorization:"Bearer "+key},signal:controller?controller.signal:undefined});
      if(!res.ok)return null;
      var rows=await res.json();if(!Array.isArray(rows)||!rows.length)return null;
      var current=ukParts(Date.now()).day,nextDay=tomorrow(current),times={};
      rows.sort(function(a,b){return Date.parse(b.scraped_at||"")-Date.parse(a.scraped_at||"")});
      for(var i=0;i<rows.length;i++){
        var item=rows[i],stamp=Date.parse(item.scraped_at||"");
        if(!item.data||!Number.isFinite(stamp)||ukParts(stamp).day!==current)continue;
        if(!times[current])times[current]=waterFromSnapshot(item.data,current,false);
        if(!times[nextDay])times[nextDay]=waterFromSnapshot(item.data,nextDay,true);
        if(times[current]&&times[nextDay])break;
      }
      if(!times[current])delete times[current];
      if(!times[nextDay])delete times[nextDay];
      return Object.keys(times).length?times:null;
    }catch(_){return null}
    finally{if(timer)clearTimeout(timer)}
  }

  async function refresh(){
    if(loading)return;loading=true;
    try{
      if(!window.UATOFeed||typeof window.UATOFeed.schedule!=="function")throw Error("Schedule client missing");
      var result=await window.UATOFeed.schedule();
      if(Array.isArray(result.park)){scheduled=result;scheduled.waterpark=waterData;render()}
    }catch(_){render()}
    try{
      waterData=await legacyWater(panels[0].root);
      if(!scheduled)scheduled={park:[],waterpark:waterData};
      else scheduled.waterpark=waterData;
      render();
    }finally{loading=false}
  }
  render();refresh();setInterval(render,60*1000);
  setInterval(function(){if(document.visibilityState!=="hidden")refresh()},5*60*1000);
  document.addEventListener("visibilitychange",function(){if(document.visibilityState==="visible"){render();refresh()}});
})();